import type { QuoteStaticContent } from '@core-api/editor/types/response';
import type { Question } from '../../legacy-series-types';
import { questionTextLayoutToSlideTextLayout } from '../converters/question/question-text-layout-to-slide-text-layout';
import { questionToSlideImageReference } from '../converters/question/question-to-slide-image-reference';
import { questionLayoutToSlideLayout } from '../converters/question/question-layout-to-slide-layout';

export const getQuoteStaticContent = (question: Question) => {
  const [slideLayout] = questionLayoutToSlideLayout(question.layout);

  const slideTextLayout = questionTextLayoutToSlideTextLayout(question.layout);

  const content: QuoteStaticContent = {
    layout: slideLayout,
    type: 'quote',
    label: question.title_meta,
    text: 'quote',
    quote: question.question,
    author: question.question_description,
    image: {
      ...questionToSlideImageReference(question),
    },
    textAlignment: {
      textHorizontalAlign: slideTextLayout.textHorizontalAlign,
      textVerticalAlign: slideTextLayout.textVerticalAlign,
    },
    textSizeOffset: slideTextLayout.textSizeOffset,
  };

  return content;
};
